import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthState } from '../../interfaces/auth/IAuthState';

export const selectAuthState = createFeatureSelector<IAuthState>('auth');

export const selectAuth = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState
);

export const selectRegistrationAuth = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.registration
);
export const selectRegistrationError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.registration.error
);
export const selectVerificationCodeError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.verifyCode.error
);
export const selectVerificationCodeLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.verifyCode.loading
);
export const selectLoginError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.login.error
);
export const selectLoginLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.login.loading
);

export const selectRegistrationLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.registration.loading
);
export const selectResetPasswordLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.resetPassword.loading
);

export const selectResetPasswordError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.resetPassword.error
);

export const selectChangePasswordLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.changePassword.loading
);

export const selectChangePasswordError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.changePassword.error
);

// auth service selecotors
export const selectRefreshKeys = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.refreshKeys.keys
);

export const selectRefreshKeysLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.refreshKeys.loading
);

export const selectRefreshKeysError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.refreshKeys.error
);

export const selectCreateRefreshKeyResult = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.createRefreshKey.result
);

export const selectCreateRefreshKeyLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.createRefreshKey.loading
);

export const selectCreateRefreshKeyError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.createRefreshKey.error
);

export const selectRevokeRefreshKeyLoading = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.revokeRefreshKey.loading
);

export const selectRevokeRefreshKeyError = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.revokeRefreshKey.error
);

export const selectRevokingUuid = createSelector(
  selectAuthState,
  (authState: IAuthState) => authState.revokeRefreshKey.revokingUuid
);

